export default __webpack_public_path__ + "static/media/07_Spot-5-different-birds.37416545.jpg";